<template>
    <div v-if="showContent" class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">
        <popup
            :width="popup.popupWidth"
            :bg-content="popup.popupBgc"
            :full="popup.popupFull"
            :title="popup.popupName"
            v-model="popup.popupActive"
            v-if="popup.popupActive"
        >
            <user-edit v-if="popup.popupType === 'editUser' || popup.popupType === 'createUser'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType" />
            <user-permission-edit v-if="popup.popupType === 'editUserPermission'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType" />
            <team-edit v-if="popup.popupType === 'editTeam' || popup.popupType === 'createTeam'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType" />
            <leads-edit v-if="popup.popupType === 'editLead'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType" />
            <advertiser-edit v-if="popup.popupType === 'editAdvertiser' || popup.popupType === 'createAdvertiser' || popup.popupType === 'cloneAdvertiser'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType" />
            <integration-edit v-if="popup.popupType === 'editIntegration' || popup.popupType === 'createIntegration'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType" />
            <team-integrations-edit v-if="popup.popupType === 'editTeamIntegration' || popup.popupType === 'createTeamIntegration'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType" />
            <team-integration-edit-when-grouped-team v-if="popup.popupType === 'createTeamIntegrationWhenGroupedTeam' || popup.popupType === 'editTeamIntegrationWhenGroupedTeam'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType" />
            <EditLanding v-if="popup.popupType === 'addLanding' || popup.popupType === 'editLanding' || popup.popupType === 'addPreLanding' || popup.popupType === 'editPrelanding'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType"/>
            <Domains v-if="popup.popupType === 'addDomain' || popup.popupType === 'editDomain'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType"/>
            <Campaign v-if="popup.popupType === 'addCampaign' || popup.popupType === 'editCampaign'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType"/>
            <Hold v-if="popup.popupType === 'addHold' || popup.popupType === 'editHold'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType"/>
            <Geo v-if="popup.popupType === 'editGeo' || popup.popupType === 'addGeo'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType"/>
            <UpdatePassword v-if="popup.popupType === 'updateUserPass'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType"/>
            <TransferDomain v-if="popup.popupType === 'editTranferDomain'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType"/>
            <CodeCampaign v-if="popup.popupType === 'codeCampaign'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType"/>
            <Tracker v-if="popup.popupType === 'tracker'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType"/>
            <LandingsADV v-if="popup.popupType === 'landingsAdvPopup'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType" />
            <LeadComments v-if="popup.popupType === 'commentLead'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType" />
            <LeadHistoryStatuses v-if="popup.popupType === 'leadHistoryStatuses'" :popupData="popup.popupData" />
            <Permission v-if="popup.popupType === 'createPermission' || popup.popupType === 'addPermissionModule' || popup.popupType === 'editPermission' || popup.popupType === 'editPermissionModule'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType" />
            <Postback v-if="popup.popupType === 'addPostback' || popup.popupType === 'editPostback'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType" />
            <Logs v-if="popup.popupType === 'getLogs'" :popupData="popup.popupData" :popupButton="popup.popupName" :popupType="popup.popupType" />
            <lead-info-integration v-if="popup.popupType === 'leadInfoIntegration'" :popupData="popup.popupData"/>
            <add-card v-if="popup.popupType === 'addCard' || popup.popupType === 'editCard'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <card-logs v-if="popup.popupType === 'cardLogs'" :popupData="popup.popupData"/>
            <CreateMessageSms v-if="popup.popupType === 'createMessageSms' || popup.popupType === 'updateMessageSms'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <SmsSetting v-if="popup.popupType === 'createSettingSms' || popup.popupType === 'updateSettingSms'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <CopyIntegrations v-if="popup.popupType === 'copyIntegrations'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <GlobalIntegrationTime v-if="popup.popupType === 'globalIntegrationTime'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <AddOffer  v-if="popup.popupType === 'addOffer' || popup.popupType === 'editOffer'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <FinTeams  v-if="popup.popupType === 'selectTeams' || popup.popupType === 'selectTeams'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <TestInt  v-if="popup.popupType === 'testIntegration'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <Relation  v-if="popup.popupType === 'createRelation' || popup.popupType === 'editRelation'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <DetailsManagement  v-if="popup.popupType === 'detailsPopupManagement'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <GlobalIntUpdate  v-if="popup.popupType === 'globalIntegrationUpdate'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <Statuses  v-if="popup.popupType === 'createStatus' || popup.popupType === 'editStatus'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <RecyclePopup  v-if="popup.popupType === 'recycle'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <ErrorStatusInfo  v-if="popup.popupType === 'errorStatusInfo'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <EditIntegrationTime  v-if="popup.popupType === 'editIntegrationTeamTime'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <UpdateStatus v-if="popup.popupType === 'updateLeadStatuses'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <DetailsLogs v-if="popup.popupType === 'detailsLogs'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <SystemSetting  v-if="popup.popupType === 'editSystemSettings'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <AutologinInfo  v-if="popup.popupType === 'autologinInfo'" :popupData="popup.popupData" :popupType="popup.popupType"/>
            <Automation  v-if="popup.popupType === 'automation'" :popupData="popup.popupData" :popupType="popup.popupType"/>
        </popup>
        <v-nav-menu
            :navMenuItems="navMenuItems"
            title="Network"
            parent=".layout--main"/>

        <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
            <div id="content-overlay"/>

            <!-- Navbar -->
            <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
                <the-navbar-horizontal
                    :navbarType="navbarType"
                    :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"/>

                <div style="height: 62px" v-if="navbarType === 'static'"></div>

                <h-nav-menu
                    :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
                    :navMenuItems="navMenuItems"/>
            </template>

            <template v-else>
                <the-navbar-vertical
                    v-if="user"
                    :navbarColor="navbarColor"
                    :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"/>
            </template>
            <!-- /Navbar -->

            <div class="content-wrapper" ref="wrapper">

                <div class="router-view">
                    <div class="router-content">
                        <transition :name="routerTransition">
                            <div v-if="($route.meta.breadcrumb || $route.meta.pageTitle) && brand !== 'leadingsolutions'"
                                 class="router-header flex flex-wrap items-center mb-6">
                                <div
                                    class="content-area__heading"
                                    :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                                    <h2 class="mb-1">{{ $t(`sideMenu.${routeTitle}`) }}</h2>
                                </div>

                                <!-- BREADCRUMB -->
                                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb"
                                               :route="$route" :isRTL="$vs.rtl"/>

                            </div>
                        </transition>

                        <div class="content-area__content">
                            <back-to-top/>
                            <transition :name="routerTransition" mode="out-in">
                                <router-view @changeRouteTitle="changeRouteTitle"
                                             @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)"/>
                            </transition>
                            <vue-progress-bar></vue-progress-bar>
                        </div>
                    </div>
                </div>
            </div>
            <!--<the-footer />-->
        </div>
    </div>
</template>


<script>
import BackToTop from '@/layouts/components/backToTop/BackToTop.vue'
import HNavMenu from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue'
import navMenuItems from '../../layouts/components/vertical-nav-menu/navMenuItems.js'
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter from '@/layouts/components/TheFooter.vue'
import themeConfig from '../../../themeConfig.js'
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'

import EventBus from '@/store/eventBus'
import UserEdit from '@/views/users/UserEdit'
import UserPermissionEdit from "@/views/users/UserPermissionEdit"
import AdvertiserEdit from '@/views/settings/advertisers/AdvertiserEdit'
import IntegrationEdit from '@/views/settings/advertisers/IntegrationEdit'
import TeamEdit from '@/views/settings/teams/TeamEdit'
import LeadsEdit from '@/views/statistics/leads/LeadsEdit'
import TeamIntegrationsEdit from '@/views/settings/teams/TeamIntegrationsEdit'
import TeamIntegrationEditWhenGroupedTeam from '@/views/settings/teams/GroupedByAdvertiser/TeamIntegrationEditWhenGroupedTeam'
import EditLanding from '@/views/settings/landings/Popup'
import Domains from '@/views/settings/domains/Popup'
import Campaign from '@/views/campaigns/Popup'
import CodeCampaign from '@/views/campaigns/CodePopup'
import Hold from '@/views/settings/hold/Popup'
import Geo from '@/views/settings/geo/Popup'
import UpdatePassword from '@/views/users/updatePasswordPopup'
import TransferDomain from '@/views/domains/Popup'
import Tracker from '@/views/users/TrackerPupup'
import LandingsADV from '@/views/statistics/advertisers/Landings'
import LeadComments from '@/views/statistics/leads/LeadComments'
import LeadHistoryStatuses from '@/views/statistics/leads/LeadHistoryStatuses'
import Permission from '@/views/settings/permissions/PermissionsPopup'
import Postback from '@/views/postbacks/Popup'
import Logs from '@/views/postbacks/Logs'
import AddCard from '@/views/finance/cards/Popup'
import FinTeams from '@/views/finance/statistic/Teams'
import GlobalIntUpdate from '@/views/settings/advertisers/IntGlobalUpdate'

import CardLogs from '@/views/finance/cards/CardLogs'

import ErrorHandler from '@/utils/errorHandler'
import LeadInfoIntegration from '@/views/statistics/leads/InfoIntegration'
import CreateMessageSms from '@/views/settings/sms/messages/Popup'
import SmsSetting from '@/views/settings/sms/settings/Popup'
import CopyIntegrations from '@/views/settings/teams/CopyIntegrations'
import GlobalIntegrationTime from '@/views/settings/advertisers/GlobalIntegrationTime'
import AddOffer from '@/views/settings/offers/AddOffer'
import TestInt from "@/views/settings/advertisers/TestInt"
import Relation from '@/views/settings/management/Popup'
import Statuses from '@/views/settings/statuses/Popup'
import DetailsManagement from '@/views/settings/management/DetailsPopup'
import RecyclePopup from "@/views/statistics/recycle/RecyclePopup"
import ErrorStatusInfo from "@/views/statistics/leads/ErrorStatusInfo"
import EditIntegrationTime from '@/views/settings/teams/UpdateTime.vue'
import UpdateStatus from "@/views/statistics/leads/UpdateStatus.vue"
import getUseServer from "@/utils/getServer"
import DetailsLogs from "@/views/logs/leads/DetailsLogs.vue"
import SystemSetting from '@/views/settings/system/Popup'
import AutologinInfo from '@/views/statistics/leads/AutologinInfo.vue'
import Automation from '@/views/statistics/recycle/Automation.vue'

export default {
    components: {
        TestInt,
        TeamIntegrationEditWhenGroupedTeam,
        BackToTop,
        HNavMenu,
        TheFooter,
        TheNavbarHorizontal,
        TheNavbarVertical,
        VNavMenu,
        UserEdit,
        UserPermissionEdit,
        AdvertiserEdit,
        IntegrationEdit,
        TeamEdit,
        TeamIntegrationsEdit,
        EditLanding,
        Domains,
        Campaign,
        LeadsEdit,
        Hold,
        Geo,
        UpdatePassword,
        TransferDomain,
        CodeCampaign,
        Tracker,
        LandingsADV,
        LeadComments,
        LeadHistoryStatuses,
        Permission,
        Postback,
        Logs,
        LeadInfoIntegration,
        AddCard,
        CardLogs,
        CreateMessageSms,
        SmsSetting,
        CopyIntegrations,
        GlobalIntegrationTime,
        AddOffer,
        FinTeams,
        Relation,
        GlobalIntUpdate,
        Statuses,
        DetailsManagement,
        RecyclePopup,
        ErrorStatusInfo,
        EditIntegrationTime,
        UpdateStatus,
        DetailsLogs,
        SystemSetting,
        AutologinInfo,
        Automation
    },
    data() {
        return {
            popup: {
                popupActive: false,
                popupName: '',
                popupType: '',
                popupData: {},
                full: false
            },
            footerType: themeConfig.footerType || 'static',
            hideScrollToTop: themeConfig.hideScrollToTop,
            isNavbarDark: false,
            navbarColor: themeConfig.navbarColor || '#fff',
            navbarType: themeConfig.navbarType || 'sticky',
            navMenuItems,
            routerTransition: themeConfig.routerTransition || 'none',
            routeTitle: this.$route.meta.pageTitle,
            showContent: false,
            apiURL: process.env.VUE_APP_API_URL
        }
    },

    computed: {
        brand() {
            return process.env.VUE_APP_BRAND
        },
        bodyOverlay() {
            return this.$store.state.bodyOverlay
        },
        contentAreaClass() {
            if (this.mainLayoutType === 'vertical') {
                if (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
                else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
                else return 'content-area-full'
            } else return 'content-area-full'
        },
        footerClasses() {
            return {
                'footer-hidden': this.footerType === 'hidden',
                'footer-sticky': this.footerType === 'sticky',
                'footer-static': this.footerType === 'static'
            }
        },
        isAppPage() {
            return this.$route.meta.no_scroll
        },
        isThemeDark() {
            return this.$store.state.theme === 'dark'
        },
        layoutTypeClass() {
            return `main-${this.mainLayoutType}`
        },
        mainLayoutType() {
            return this.$store.state.mainLayoutType
        },
        navbarClasses() {
            return {
                'navbar-hidden': this.navbarType === 'hidden',
                'navbar-sticky': this.navbarType === 'sticky',
                'navbar-static': this.navbarType === 'static',
                'navbar-floating': this.navbarType === 'floating'
            }
        },
        verticalNavMenuWidth() {
            return this.$store.state.verticalNavMenuWidth
        },
        windowWidth() {
            return this.$store.state.windowWidth
        },
        user() {
            return this.$store.getters.userState
        }
    },

    watch: {
        'popup.popupActive'(value) {
            if (value) {
                document.body.classList.add('ov-hidden')
            } else {
                document.body.classList.remove('ov-hidden')
            }
        },
        '$route'() {
            this.popup.popupActive = false
            this.routeTitle = this.$route.meta.pageTitle
        },
        isThemeDark(val) {
            const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
            this.updateNavbarColor(color)
        },
        '$store.state.mainLayoutType'(val) {
            this.setNavMenuVisibility(val)
        },

        userEmail(newValue) {
            this.showContent = !!newValue
        },

        '$store.getters.authError'(val) {
            const server = this.getServer()
            if(this.$store.getters.authError) {
                if(localStorage.getItem(`start_${server.name}`)) {
                    this.$store.dispatch('autologinGoStartUser')
                } else {
                    this.$store.dispatch('CLEAR_TOKEN')
                    window.location.reload()
                }
            }
        }
    },

    async mounted() {
        window.onfocus = async (event) => {
            try {
                const server = (JSON.parse(process.env.VUE_APP_API_SERVERS) || [])
                    .find(server => server.name === localStorage.getItem('server'))

                if (!server) {
                    localStorage.removeItem('server')
                    await this.$store.dispatch('AUTH_ERROR', 'Access denied')
                } else {
                    if (this.$route.path !== '/login') {
                        await this.$store.dispatch('GET_USER_DATA')
                    }
                }
            } catch (e) {
                EventBus.$emit('emitPopupEvent', {type: 'close'})
                new ErrorHandler(e).send
            }
        }

        try {
            await this.login()
            this.showContent = true

            window.addEventListener('resize', this.windowResize)
            this.windowResize()
        } catch (e) {
            EventBus.$emit('emitPopupEvent', {type: 'close'})
            new ErrorHandler(e).send
        }
    },

    methods: {
        windowResize() {
            this.$nextTick(() => {
                const wrapper = this.$refs.wrapper
                if (wrapper) {
                    this.$store.commit('SET_WRAPPER_WIDTH', wrapper.clientWidth)
                }
            })
        },
        getServer() {
            return getUseServer()
        },
        async login() {
            try {
                const start_token = localStorage.getItem(`start_${this.getServer().name}`)
                if(start_token) {
                    const user = await this.$store.dispatch('GET_USER_DATA', start_token)
                    this.$store.commit('SET_AUTOLOGIN_USER', user)
                    await this.$store.dispatch('GET_USER_DATA')
                } else {
                    await this.$store.dispatch('GET_USER_DATA')
                }
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        changeRouteTitle(title) {
            this.routeTitle = title
        },
        updateNavbarColor(val) {
            this.navbarColor = val
            if (val === '#fff') this.isNavbarDark = false
            else this.isNavbarDark = true
        },
        setNavMenuVisibility(layoutType) {
            if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
                this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
                this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
            } else {
                this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
            }
        },

        openPopup(data) {
            Object.entries(data).map(([key, value]) => {
                if (key === 'ids') key = 'data'

                let name = key[0].toUpperCase() + key.slice(1);
                this.popup[`popup${name}`] = value
            })

            this.popup.popupActive = true
        }
    },
    created() {
        const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
        this.updateNavbarColor(color)
        this.setNavMenuVisibility(this.$store.state.mainLayoutType)

        EventBus.$on('emitPopupEvent', param => {
            if (param.type && param.type === 'close') {
                this.$set(this, 'popup', {
                    popupActive: false,
                    full: false
                })
            } else if (param.type && param.type !== 'close') {
                this.openPopup(param)
            } else {
                alert(`Chosen popup is ${param.type} but it's not exist`)
            }
        })
    },
    beforeDestroy() {
        EventBus.$emit('emitPopupEvent', {type: 'close'})
        EventBus.$off('emitPopupEvent')

        window.removeEventListener('resize', this.windowResize)
    }
}

</script>

<style lang="scss">
//#vs10__listbox {
//    z-index: 999999999999 !important;
//    position: relative;
//}

.ov-hidden {
    overflow: hidden;
}

.vs-con-input-label.is-label-placeholder {
    margin-top: 0;
}

/*.vs-popup--content {*/
/*    overflow: initial !important;*/
/*}*/

.display-item {
    display: none !important;
}

.tooltip {
    display: block !important;
    z-index: 10000;

    .tooltip-inner {
        background: black;
        color: white;
        border-radius: 16px;
        padding: 5px 10px 4px;
    }

    .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: black;
    }

    &[x-placement^="top"] {
        margin-bottom: 5px;

        .tooltip-arrow {
            border-width: 5px 5px 0 5px;
            border-left-color: transparent !important;
            border-right-color: transparent !important;
            border-bottom-color: transparent !important;
            bottom: -5px;
            left: calc(50% - 5px);
            margin-top: 0;
            margin-bottom: 0;
        }
    }

    &[x-placement^="bottom"] {
        margin-top: 5px;

        .tooltip-arrow {
            border-width: 0 5px 5px 5px;
            border-left-color: transparent !important;
            border-right-color: transparent !important;
            border-top-color: transparent !important;
            top: -5px;
            left: calc(50% - 5px);
            margin-top: 0;
            margin-bottom: 0;
        }
    }

    &[x-placement^="right"] {
        margin-left: 5px;

        .tooltip-arrow {
            border-width: 5px 5px 5px 0;
            border-left-color: transparent !important;
            border-top-color: transparent !important;
            border-bottom-color: transparent !important;
            left: -5px;
            top: calc(50% - 5px);
            margin-left: 0;
            margin-right: 0;
        }
    }

    &[x-placement^="left"] {
        margin-right: 5px;

        .tooltip-arrow {
            border-width: 5px 0 5px 5px;
            border-top-color: transparent !important;
            border-right-color: transparent !important;
            border-bottom-color: transparent !important;
            right: -5px;
            top: calc(50% - 5px);
            margin-left: 0;
            margin-right: 0;
        }
    }

    &[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity .15s, visibility .15s;
    }

    &[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity .15s;
    }
}

.vs-table--thead tr th .vs-table-text {
    text-transform: uppercase;
}
</style>
